import React from 'react';
import { connect } from 'react-redux';
import { NAVIGATION } from '../../config';

import {
  getProjects,
  getSelectedProject,
} from '../../redux/projects/projects.selectors';
import { getSelectedOrganization } from '../../selectors/organizations/organizations';
import { Organization, Project } from '../../types/entities';
import { navigation } from '../../utils';
import { Sidebar } from '@wix/design-system';
import { SidebarFooter } from './sidebar-footer/sidebar-footer';
import { SidebarOrganizationLevelMenu } from './sidebar-organization-level-menu/sidebar-organization-level-menu';
import { SidebarProjectLevelMenu } from './sidebar-project-level-menu/sidebar-project-level-menu';
import styles from './sidebar.scss';
import {
  getOrganizationLevelMenuItems,
  getProjectLevelMenuItems,
  getSelectedMenuItemId,
} from './sidebar.selectors';
import { SidebarMenuItem } from './sidebar.types';
import _ from 'lodash';

interface Props {
  organization: Organization;
  project: Project;
  projects: Project[];
  organizationLevelMenuItems: SidebarMenuItem[];
  projectLevelMenuItems: SidebarMenuItem[];
  selectedMenuItemId: string;
}

class SidebarComponent extends React.Component<Props, {}> {
  public goToProjectPage(): void {
    navigation.goToPath(NAVIGATION.PROJECTS_STATE, {
      organizationId: this.props.organization.id,
    });
  }

  public render() {
    const {
      project,
      projects,
      organization,
      selectedMenuItemId,
      projectLevelMenuItems,
      organizationLevelMenuItems,
    } = this.props;

    return (
      <div className={styles.wrapper}>
        <Sidebar>
          {_.isEmpty(project) &&
            SidebarOrganizationLevelMenu({
              organizationLevelMenuItems,
              selectedMenuItemId,
              project,
            })}

          {SidebarProjectLevelMenu({
            projectLevelMenuItems,
            project,
            projects,
            organization,
            selectedMenuItemId,
            onBackHandler: this.goToProjectPage.bind(this),
          })}

          {SidebarFooter()}
        </Sidebar>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  organization: getSelectedOrganization(state),
  project: getSelectedProject(state),
  projects: getProjects(state),
  organizationLevelMenuItems: getOrganizationLevelMenuItems(state),
  projectLevelMenuItems: getProjectLevelMenuItems(state),
  selectedMenuItemId: getSelectedMenuItemId(state),
});

export const SidebarContainer = connect(mapStateToProps)(SidebarComponent);
